import { Component, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { EntityBase, GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { IncrementalKind, SellStatusKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { InvVoucherDetailFilterComponent } from "src/app/backoffice/inv/invvoucher/inv-voucher-detail-filter/inv-voucher-detail-filter.component";
import { ReferenceVoucherListComponent } from "src/app/backoffice/inv/invvoucher/reference-voucher-list/reference-voucher-list.component";
import { SellVoucherHeader } from "../../models/sell-voucher-header.model";
import { SellVoucherFormComponent } from "../sell-voucher-form/sell-voucher-form.component";
import { SellVoucherHeaderImportExcelFormComponent } from "../sell-voucher-header-import-excel/sell-voucher-header-import-excel-form.component";

@Component({
  selector: "ngx-sell-voucher-list",
  templateUrl: "./sell-voucher-list.component.html",
  styleUrls: ["./sell-voucher-list.component.scss"],
})
export class SellVoucherListComponent extends BaseListComponent {
  filterInfo: NameValue[] = [];
  filters: GridFilter[];
  actions: EntityListAction[];
  @ViewChild("grid") grid: KGridComponent;
  unSortableFilterable: string[] = [];
  constructor(private lookupservice: LookupService, private _tabsservice: TabularService, private splashFormService: SplashFormService) {
    super();
    this.inputEditorform = SellVoucherFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  get currentFiscalYear() {
    return this.accountService.authService.currentFiscalYear;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.filterInfo = undefined;
    this.actions = undefined;
  }
  ngOnInit() {
    this.unSortableFilterable.push("RemainValue");
    this.apiName = "SellVoucherHeader/GetWithCustomFilter";
    this.label = "فهرست اسناد سند فروش";
    this.areaName = "SellCustomer";
    this.setactions();
    if (this.currentFiscalYear) {
      this.filterInfo.push({ Name: "FiscalYearId", Value: this.currentFiscalYear?.Id, Operator: "eq" });
      this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.filterInfo.push({ Name: "FiscalYearId", Value: x.Id, Operator: "eq" });
          this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
        }
      });
  }
  createAccVoucher(gridFilter: GridFilter[]) {
    this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
    this.httpCommonService
      .create("SellVoucherHeader/CreateAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
          this.sts.showDialog("اسناد با موفقیت صادر شد.", "");
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در صدور اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  deleteAccVoucher(gridFilter: GridFilter[]) {
    this.splashFormService.openDialog("", "در حال حذف سند حسابداری");
    this.httpCommonService
      .create(this.apiName.split("/")[0] + "/DeleteAccVoucher", gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
          this.sts.showDialog("اسناد با موفقیت حذف شد.", "");
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در حذف اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: SellVoucherHeader,
    onRowsSelected: SellVoucherHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    if (onRowSelected && (!onRowsSelected || onRowsSelected.length <= 0)) onRowsSelected = [onRowSelected];
    let SellVoucherHeaderIds: number[];
    ///نمایش سند حسابداری
    if (action.name === "ViewAccVoucher") {
      if (onRowSelected) {
        if (!onRowSelected.AccVoucherFixNumber) {
          this.sts.showDialog("سندحسابداری صادر نشده است.", "خطا");
          return;
        }
        this.httpCommonService
          .getItem("SellVoucherHeader/ViewAccVoucher", onRowsSelected.length > 0 ? onRowsSelected[0].Id : onRowSelected.Id)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              var datatrasfer: Datatransfer = <Datatransfer>{};
              datatrasfer.apiName = "AccVoucherHeader";
              datatrasfer.label = "صدور سند حسابداری";
              datatrasfer.areaName = "Accounting";
              datatrasfer.currentrow = x;
              const menu = <ITab>{
                title: `سند حسابداری-(نمایش)`,
                isCloseable: true,
                active: true,
                responsive: true,
                componentType: AccVoucherFormComponent,
                data: [
                  { provide: EntityBase, useValue: x },
                  { provide: Datatransfer, useValue: datatrasfer },
                  { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: x[""] } },
                ],
              };
              this._tabsservice.open(menu);
            },
            (error) => this.sts.showDialog(`خطا در نمایش سند:${Utilities.getHttpResponseMessage(error)}`, "خطا")
          );
      }
    }
    ///سند حسابداری
    if (action.name === "CreateAccVoucher" || action.name === "DeleteAccVoucher") {
      if (
        onRowSelected &&
        onRowSelected.HasJournalVoucher &&
        (onRowSelected.IncrementalKindCode === IncrementalKind.Decrement ||
          (onRowSelected.IncrementalKindCode !== IncrementalKind.Neutral && onRowSelected.StatusKindCode === SellStatusKind.Confirmed))
      ) {
        if (!SellVoucherHeaderIds) SellVoucherHeaderIds = [];
        SellVoucherHeaderIds.push(onRowSelected.Id);
      }
      if (onRowsSelected && onRowsSelected.length > 0) {
        onRowsSelected.forEach((x) => {
          if (x) {
            if (!SellVoucherHeaderIds) SellVoucherHeaderIds = [];
            if (
              !SellVoucherHeaderIds.some((id) => id === x.Id) &&
              x.HasJournalVoucher &&
              ((action.name === "CreateAccVoucher" &&
                (x.IncrementalKindCode === IncrementalKind.Decrement ||
                  (x.IncrementalKindCode !== IncrementalKind.Neutral && x.StatusKindCode === SellStatusKind.Confirmed))) ||
                (action.name === "DeleteAccVoucher" && x.StatusKindCode === SellStatusKind.AccountRegistered))
            )
              SellVoucherHeaderIds.push(x.Id);
          }
        });
      }
      if (!isAllSelected && !SellVoucherHeaderIds.some((x) => 1 === 1)) {
        this.sts.showDialog("اسناد تائید نشده است.", "");
        return;
      }
      let filter: GridFilter = {
        Type: "F",
        Filed: "SellVoucherHeaderIds",
        Value: SellVoucherHeaderIds,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      };
      if (SellVoucherHeaderIds && SellVoucherHeaderIds.length > 0) gridFilter.push(filter);

      if (action.name === "CreateAccVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل صدور سند حسابداری نیست", "خطا");
          return;
        }
        this.sts.showDialog("آیا از صدور سند حسابداری اطمینان دارید؟", "صدور سند", DialogType.confirm, () => this.createAccVoucher(gridFilter));
      }
      if (action.name === "DeleteAccVoucher") {
        if (gridFilter.length <= 0) {
          this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل حذف نیست", "خطا");
          return;
        }
        this.sts.showDialog("آیا از حذف سند حسابداری اطمینان دارید؟", "حذف سند", DialogType.confirm, () => this.deleteAccVoucher(gridFilter));
      }
    }
    ///تایید اسناد
    if (action.name === "VoucherConFirmed" && onRowsSelected.length > 0) {
      onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === SellStatusKind.Registered);
      if (!onRowsSelected || onRowsSelected.length <= 0) {
        this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل تایید نیست", "خطا");
      }
      this.lookupservice
        .getLookupbyCode("SELL", "StatusKind", SellStatusKind.Confirmed)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((sk) => {
          if (sk) {
            onRowsSelected.forEach((x) => {
              x.StatusKindId = sk.Id;
              x.StatusKindCode = sk.Code;
              x.StatusKindTitle = sk.Title;
            });
            this.splashFormService.openDialog("", "در حال تایید اسناد");
            this.httpCommonService
              .bulkUpdate(this.apiName.split("/")[0], onRowsSelected)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (x) => {
                  this.splashFormService.closeLoading();
                  this._tabsservice.tabItemonRefreshData.next(this.apiName);
                  this.sts.showDialog("اسناد با موفقیت تایید شد.", "");
                },
                (error) => {
                  this.splashFormService.closeLoading();
                  this.sts.showDialog(`خطا در تایید اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
                }
              );
          }
        });
    }

    ///برگشت از تایید اسناد
    if (action.name === "VoucherDeConfirm" && onRowsSelected.length > 0) {
      onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === SellStatusKind.Confirmed && !x.HasReferencedVoucherTo);
      if (!onRowsSelected || onRowsSelected.length <= 0) {
        this.sts.showDialog("هیچ سندی انتخاب نشده یا وضعیت اسناد انتخاب شده تایید نیست", "خطا");
      }
      this.lookupservice
        .getLookupbyCode("SELL", "StatusKind", SellStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((sk) => {
          if (sk) {
            onRowsSelected.forEach((x) => {
              if (!x.HasReferencedVoucherTo) {
                x.StatusKindId = sk.Id;
                x.StatusKindCode = sk.Code;
                x.StatusKindTitle = sk.Title;
              }
            });
            this.splashFormService.openDialog("", "در حال برگشت از تایید اسناد");
            this.httpCommonService
              .bulkUpdate(this.apiName.split("/")[0], onRowsSelected)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (x) => {
                  this._tabsservice.tabItemonRefreshData.next(this.apiName);
                  this.splashFormService.closeLoading();
                  this.sts.showDialog("اسناد با موفقیت برگشت از تایید شد.", "");
                },
                (error) => {
                  this.splashFormService.closeLoading();
                  this.sts.showDialog(`خطا در برگشت از تایید اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
                }
              );
          }
        });
    }

    ///اختتام اسناد
    if (action.name === "VoucherClosing" && onRowsSelected.length > 0) {
      let isCancelled: boolean = false;
      let onRowsSelected1 = onRowsSelected.filter((x) => x.StatusKindCode === SellStatusKind.Closing);
      if (!onRowsSelected1 || onRowsSelected1.length <= 0) {
        onRowsSelected1 = onRowsSelected.filter((x) => x.StatusKindCode === SellStatusKind.Registered);
        isCancelled = onRowsSelected1 && onRowsSelected1.length > 0;
      }
      if (!onRowsSelected1 || onRowsSelected1.length <= 0) {
        this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل اختتام نیست", "خطا");
        return;
      }
      this.lookupservice
        .getLookupbyCode("SELL", "StatusKind", !isCancelled ? SellStatusKind.Registered : SellStatusKind.Closing)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((sk) => {
          if (sk) {
            onRowsSelected1.forEach((x) => {
              x.StatusKindId = sk.Id;
              x.StatusKindCode = sk.Code;
              x.StatusKindTitle = sk.Title;
            });
            this.httpCommonService
              .bulkUpdate(this.apiName.split("/")[0], onRowsSelected1)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (x) => {
                  this._tabsservice.tabItemonRefreshData.next(this.apiName);
                  if (isCancelled) this.sts.showDialog("اسناد با موفقیت مختومه شد.", "");
                  else this.sts.showDialog("اسناد با موفقیت برشگت از مختومه شد.", "");
                },
                (error) => this.sts.showDialog(`خطا در اختتام اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
              );
          }
        });
    }

    ///ابطال /برگشت از ابطال
    if (action.name === "VoucherCancelled" && onRowsSelected.length > 0) {
      let isCancelled: boolean = false;
      let onRowsSelected1 = onRowsSelected.filter((x) => x.StatusKindCode === SellStatusKind.Registered);
      if (!onRowsSelected1 || onRowsSelected1.length <= 0) {
        onRowsSelected1 = onRowsSelected.filter((x) => x.StatusKindCode === SellStatusKind.Cancelled);
        isCancelled = onRowsSelected1 && onRowsSelected1.length > 0;
      }
      if (!onRowsSelected1 || onRowsSelected1.length <= 0) {
        this.sts.showDialog("هیچ سندی انتخاب نشده یا وضعیت اسناد انتخاب شده تایید نیست", "خطا");
      }
      this.lookupservice
        .getLookupbyCode("SELL", "StatusKind", isCancelled ? SellStatusKind.Registered : SellStatusKind.Cancelled)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((sk) => {
          if (sk) {
            onRowsSelected1.forEach((x) => {
              x.StatusKindId = sk.Id;
              x.StatusKindCode = sk.Code;
              x.StatusKindTitle = sk.Title;
            });
            this.httpCommonService
              .bulkUpdate(this.apiName.split("/")[0], onRowsSelected1)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (x) => {
                  if (isCancelled) this.sts.showDialog("اسناد با موفقیت برگشت از ابطال شد.", "");
                  else this.sts.showDialog("اسناد با موفقیت ابطال شد.", "");
                  this._tabsservice.tabItemonRefreshData.next(this.apiName);
                },
                (error) => this.sts.showDialog(`خطا در ابطال اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
              );
          }
        });
    }
    if (!onRowSelected && onRowsSelected && onRowsSelected.length > 0) onRowSelected = onRowsSelected[0];
    ///سند مبنا
    if (action.name === "SellVoucherBase" && onRowSelected != null) {
      this.dialogService
        .open(
          ReferenceVoucherListComponent,
          {
            VoucherId: onRowsSelected.length > 0 ? onRowsSelected[0].Id : onRowSelected.Id,
            apiName: action.apiName,
            areaName: action.areaName,
            label: "سند مبنا",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: any) => {});
    }
    ///سند معطوف
    if (action.name === "SellRefrenceTo" && onRowSelected != null) {
      this.dialogService
        .open(
          ReferenceVoucherListComponent,
          {
            VoucherId: onRowsSelected.length > 0 ? onRowsSelected[0].Id : onRowSelected.Id,
            apiName: action.apiName,
            areaName: action.areaName,
            label: "سند معطوف",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: any) => {});
    }
    ///فیلتر اقلام سند
    if (action.name === "InvVoucherDetailFilter") {
      this.dialogService
        .open(
          InvVoucherDetailFilterComponent,
          {
            currentrow: null,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {
          if (model && model.length > 0) this.filters = model;
        });
    }
    ///حذف فیلتر افلام
    if (action.name === "InvVoucherDetailFilterRemove") {
      this.filters = [];
    }

    ///دریافت از اکسل
    if (action.name === "ImportFromExcel") {
      var gridInfo = this.getGridInfo();
      this.dialogService
        .open(
          action.Form_Component,
          {
            gridInfo: gridInfo,
            label: action.displayName,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {
          this._tabsservice.tabItemonRefreshData.next(this.apiName);
        });
    }

    return;
  }
  setactions() {
    this.actions = [
      {
        name: "CreateAccVoucher",
        disabled: false,
        displayName: "صدور سند حسابداری",
        iconName: "icon-create_new_folder-o",
        apiName: "SellVoucherHeader/CreateAccVoucher",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "DeleteAccVoucher",
        disabled: false,
        displayName: "حذف سند حسابداری",
        iconName: "icon-delete-sweep-outline",
        apiName: "SellVoucherHeader/DeleteAccVoucher",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "ViewAccVoucher",
        disabled: false,
        displayName: "نمایش سند حسابداری",
        iconName: "icon-table_view-f",
        apiName: "InvVoucherHeader/ViewAccVoucher",
        areaName: "Inventory",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherCancelled",
        disabled: false,
        displayName: "ابطال/برگشت از ابطال ",
        iconName: "icon-blocked",
        apiName: "SellVoucherHeader/VoucherCancelled",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherConFirmed",
        disabled: false,
        displayName: "تائید سند",
        iconName: "icon-folder-open-outline",
        apiName: "SellVoucherHeader/VoucherConFirmed",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherDeConfirm",
        disabled: false,
        displayName: "برگشت از تائید",
        iconName: "icon-folder-open",
        apiName: "SellVoucherHeader/VoucherDeConfirm",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherClosing",
        disabled: false,
        displayName: "اختتام/برگشت از اختتام",
        iconName: "icon-package-variant-closed",
        apiName: "SellVoucherHeader/VoucherClosing",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "SellReportPrint",
        disabled: false,
        displayName: "چاپ سند",
        iconName: "icon-print-o",
        apiName: "SellVoucherHeader/SellReportPrint",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "SellRefrenceTo",
        disabled: false,
        displayName: "سند معطوف",
        iconName: "icon-file-document-multiple-outline",
        apiName: "SellVoucherHeader/GetSellReferenceToVouchersByVoucherId",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      ,
      {
        name: "SellVoucherBase",
        disabled: false,
        displayName: "سند مبنا",
        iconName: "icon-folder-open-outline",
        apiName: "SellVoucherHeader/GetSellReferenceVouchersByVoucherId",
        areaName: "SellCustomer",
        permission: Permission.samePermission,
      },
      {
        name: "SellVoucherDetailFilter",
        disabled: false,
        displayName: "فیلتر اقلام",
        iconName: "icon-filter-variant-plus",
        apiName: "SellVoucherHeader",
        areaName: "SellCustomer",
        permission: Permission.viewPermission,
      },
      {
        name: "SellVoucherDetailFilterRemove",
        disabled: false,
        displayName: "حذف فیلتر اقلام",
        iconName: "icon-filter-variant-minus",
        apiName: "SellVoucherHeader",
        areaName: "SellCustomer",
        permission: Permission.viewPermission,
      },
      {
        name: "ImportFromExcel",
        disabled: false,
        displayName: "ورودی اکسل",
        iconName: "icon-file-excel-o",
        apiName: "SellVoucherHeader/ImportExcel",
        areaName: "SellCustomer",
        Form_Component: SellVoucherHeaderImportExcelFormComponent,
        permission: Permission.samePermission,
      },
    ];
  }
  getParamsForExportExcelWithPostMethod(): Promise<any> {
    let Ids: number[] = [];

    this.grid.selectedRows.forEach((x) => Ids.push(x.Id));
    let filter = this.grid.getGridFilter();
    if (Ids.length > 0)
      filter.push({
        Filed: "Ids",
        Value: Ids,
        Operator: filter[0].Operator,
        Skip: filter[0].Skip,
        Take: filter[0].Take,
        Type: "F",
        Logic: filter[0].Logic,
      });
    return new Promise((resolve, reject) => {
      resolve({ GridInfo: this.getGridInfo(), Filters: filter });
    });
  }

  getGridInfo(): GridColumnInfoDetail[] {
    let columns: GridColumnInfoDetail[] = [];
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "VoucherNo", orderindex: 0, title: "شماره سند" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "ShamsiVoucherDate", orderindex: 1, title: "تاریخ سند" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "VoucherKindCode", orderindex: 2, title: "کد نوع سند" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "SellKindCode", orderindex: 3, title: "کد نوع فروش" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "CustomerCode", orderindex: 4, title: "شماره مشتری" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "RowNumber", orderindex: 5, title: "ردیف" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Comment", orderindex: 6, title: "شرح قلم" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "GoodsCode", orderindex: 7, title: "کد کالا" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "GoodsUnitCode", orderindex: 8, title: "کد واحد سنجش" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "WarehouseCode", orderindex: 9, title: "کد انبار" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Amount", orderindex: 10, title: "مقدار" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "MainAmount", orderindex: 11, title: "مقدار اصلی" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "UnitPrice", orderindex: 12, title: "نرخ" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "GoodsUnitRatio", orderindex: 13, title: "نسبت به واحد اصلی واحد شنجش" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Surplusage", orderindex: 14, title: "اضافات" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Deduction", orderindex: 15, title: "کسور" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "DiscountRate", orderindex: 16, title: "درصد تخفیف" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "DiscountAmount", orderindex: 17, title: "مبلغ تخفیف" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Tax", orderindex: 18, title: "مالیات" });

    return columns;
  }
}
